import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "sectionContainer"

export const presets = {
  width: {
    platform: "max-w-screen-section",
    marketing: "max-w-screen-marketing",
  },
}

export interface Props extends Component {
  width?: "platform" | "marketing"
}

export function SectionContainer({
  children,
  className,
  testId = COMPONENT_NAME,
  width = "platform",
}: Props) {
  return (
    <div
      className={cx(
        `w-full px-3 sm:px-6 md:px-12 lg:px-16 flex justify-center mx-auto`,
        presets.width[width],
        className,
      )}
      data-test={testId}
    >
      <div className="w-full">{children}</div>
    </div>
  )
}
